import { render, staticRenderFns } from "./side-nav-menu.vue?vue&type=template&id=de54b328"
import script from "./side-nav-menu.vue?vue&type=script&lang=js"
export * from "./side-nav-menu.vue?vue&type=script&lang=js"
import style0 from "./side-nav-menu.vue?vue&type=style&index=0&id=de54b328&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports